import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import storeImg from "../../assets/images/addProduct.png";
import ThumbLine from "../../assets/images/Exclude.svg";
import { IsNullOrEmpty, makeId } from "../../helpers/utility";
import FileAPI from "../../store/file/file.api";
import { getUploadedProductImage } from "../../store/file/file.selector";
import {
    addProductRequest,
    deleteProductRequest,
    updateProductRequest,
} from "../../store/shopping/shopping.actions";
import {
    getProducts,
    getShippingFees,
} from "../../store/shopping/shopping.selector";
import { getDeliveryAddressRequest } from "../../store/user/deliveryaddress/deliveryaddress.actions";
import { getDeliveryAddresses } from "../../store/user/deliveryaddress/deliveryaddress.selector";
import { getImage, getUserProfile } from "../../store/user/user.selector";

export default function ProductCard(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { product, isAdd } = props;
    const [bannerImageSrc, setBannerImageSrc] = useState("");
    const [discount, setDiscount] = useState(false);
    const [itemName, setitemName] = useState("");
    const [currency, setCurrency] = useState("");
    const [showShippingFees, setShippingFees] = useState(false);
    const [productShippingFees, setProductShippingFees] = useState(false);
    const [stockQuantity, setstockQuantity] = useState("");
    const [itemDescription, setitemDescription] = useState("");
    const [itemPrice, setitemPrice] = useState("");
    const [isDisabled, setDisabled] = useState(!isAdd);
    const [selectedItems, setSelectedItems] = useState([]);
    const [isValidated, setValidated] = useState(false);
    const [showPic, setPic] = useState(false);
    const [showEdit, setEdit] = useState(!isAdd);
    const [openModal, setOpenModal] = useState(false);
    const [files, setFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [firstImage, setFirstImage] = useState("");
    const [secondImage, setSecondImage] = useState("");
    const [thirdImage, setThirdImage] = useState("");
    const [fourthImage, setFourthImage] = useState("");
    const [finalDiscount, setFinalDiscount] = useState(0);
    const [discountCode, setDiscountCode] = useState(makeId(6));
    const [discountPer, setDiscountPer] = useState(0);

    const [height, setHeight] = useState(0);
    const [length, setLength] = useState(0);
    const [width, setWidth] = useState(0);
    const [weight, setWeight] = useState(0);

    useEffect(() => {
        if (parseInt(discountPer) > 0) {
            setFinalDiscount(
                parseInt(itemPrice) -
                    (parseInt(itemPrice) * parseInt(discountPer)) / 100
            );
        }
    }, [discountPer]);

    const {
        uploadProductResponse,
        products,
        deliveryAddress,
        userProfile,
        deliveryLoading,
    } = useSelector((state) => {
        return {
            uploadProductResponse: getUploadedProductImage(state),
            products: getProducts(state),
            userProfile: getUserProfile(state),
            deliveryAddress: getDeliveryAddresses(state),
            deliveryLoading: state.DeliveryAddressReducer.isLoading,
        };
    });

    useEffect(() => {
        dispatch(getDeliveryAddressRequest());
    }, []);

    useEffect(() => {
        if (openModal) {
            setUploadedFiles([]);
            setFiles([]);
        }
    }, [openModal]);

    useEffect(() => {
        if (!isAdd) {
            setDisabled(true);
        }
    }, [products]);

    const validate = () => {
        return (
            !IsNullOrEmpty(itemName) &&
            !IsNullOrEmpty(stockQuantity) &&
            !IsNullOrEmpty(itemDescription) &&
            !IsNullOrEmpty(itemPrice) &&
            (!IsNullOrEmpty(firstImage) ||
                !IsNullOrEmpty(secondImage) ||
                !IsNullOrEmpty(thirdImage) ||
                !IsNullOrEmpty(fourthImage)) &&
            parseFloat(itemPrice) > 0
        );
    };

    const handleAdd = () => {
        if (userProfile.role === "Pro" && products.length === 20) {
            Swal.fire({
                title: "Add Product",
                text: "Maximum products for Pro users exceeds. Please contact support.",
                icon: "error",
                confirmButtonText: "Yes",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
            });
            return;
        }

        if (userProfile.role === "Basic" && products.length === 10) {
            Swal.fire({
                title: "Add Product",
                text: "Maximum products for Basic users exceeds. Please Upgrade to Pro.",
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "Upgrade Pro",
                CancelButtonText: "Cancel",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
            }).then((x) => {
                if (x.isConfirmed) {
                    navigate("/page/upgradePlan");
                }
            });
            return;
        }

        if (validate()) {
            dispatch(
                addProductRequest({
                    name: itemName,
                    descriptions: itemDescription,
                    images: getImage(firstImage),
                    allAttachments: [
                        secondImage._id,
                        thirdImage._id,
                        fourthImage._id,
                    ].filter((x) => x),
                    attachments: firstImage._id,
                    price: parseFloat(itemPrice),
                    shippingFee: 0,
                    quantity: parseFloat(stockQuantity),
                    shippingInfo: selectedItems,
                    height: height,
                    length: length,
                    width: width,
                    weight: weight,
                    discountCode: discountCode,
                    discountPer: discountPer,
                })
            );
        } else {
            setValidated(true);
        }
    };

    const handleUpdate = (imgs) => {
        let data = {
            id: product._id,
            name: itemName,
            descriptions: itemDescription,
            price: parseFloat(itemPrice),
            shippingFee: 0,
            quantity: parseFloat(stockQuantity),
            shippingInfo: selectedItems,
            images: getImage(firstImage),
            allAttachments: [
                secondImage._id,
                thirdImage._id,
                fourthImage._id,
            ].filter((x) => x),
            attachments: firstImage._id,
            height: height,
            length: length,
            width: width,
            weight: weight,
            discountCode: discountCode,
            discountPer: discountPer,
        };
        dispatch(updateProductRequest(data));
        setEdit(true);
    };

    const handleDelete = () => {
        Swal.fire({
            title: "Delete Product",
            text: "Are you sure want to delete this product.?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonText: "Cancel",
            confirmButtonText: "Yes",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(
                    deleteProductRequest({
                        id: product._id,
                    })
                );
            }
        });
    };

    useEffect(() => {
        if (product._id) {
            setShippingFees(false);
            setitemName(product.name);
            setitemDescription(product.descriptions);
            setitemPrice(product.price);
            setCurrency(product.currency);
            setHeight(product.height);
            setLength(product.length);
            setWidth(product.width);
            setWeight(product.weight);
            setDiscount(product.discount);
            setDiscountPer(product.discountPer);
            setDiscountCode(
                product.discountCode ? product.discountCode : makeId(6)
            );
            setstockQuantity(
                product.quantity ||
                    (product.warehouse && product.warehouse.remaining)
            );

            if (product.attachments) {
                setFirstImage(product.attachments);
            }

            product.allAttachments &&
                product.allAttachments.forEach((x, index) => {
                    if (index === 0) {
                        setSecondImage(x);
                    }
                    if (index === 1) {
                        setThirdImage(x);
                    }
                    if (index === 2) {
                        setFourthImage(x);
                    }
                });
        }
    }, [props.product]);

    useEffect(() => {
        if (isAdd) {
            setShippingFees(false);
            setitemName("");
            setitemDescription("");
            setitemPrice("");
            setCurrency("");
            setstockQuantity("");
            setFirstImage("");
            setSecondImage("");
            setThirdImage("");
            setFourthImage("");
            setHeight("");
            setLength("");
            setWidth("");
            setWeight("");
            setDiscount(0);
            setDiscountPer(0);
            setDiscountCode(makeId(6));
            setFinalDiscount(0);
        }
    }, [props.products]);

    useEffect(() => {
        if (files.length > 0) {
            if (files.length === uploadedFiles.length) {
                const reader = new FileReader();
                reader.addEventListener(
                    "load",
                    function () {
                        setBannerImageSrc(reader.result);
                    },
                    false
                );

                if (files[0]) {
                    reader.readAsDataURL(files[0]);
                } else {
                    setBannerImageSrc("");
                }
                setLoading(false);
                setOpenModal(false);
            }
        }
    }, [uploadedFiles]);

    const changeBanner = async (e, index) => {
        const files = e.target.files[0];

        FileAPI.UploadProducts(files)
            .then((res) => {
                if (index === 1) {
                    setFirstImage(res.body.data);
                }
                if (index === 2) {
                    setSecondImage(res.body.data);
                }
                if (index === 3) {
                    setThirdImage(res.body.data);
                }
                if (index === 4) {
                    setFourthImage(res.body.data);
                }
            })
            .catch((e) => {});
    };

    let clasName = bannerImageSrc ? "addproductimage" : "img-prod-thumbnail";
    let isValid = validate();
    const myProps = {
        width: 256,
        height: 256,
        zoomWidth: 512,
        img: bannerImageSrc ? bannerImageSrc : ThumbLine,
    };
    return (
        <div className="p-4 border border-black-10 rounded-lg bg-white h-fit">
            <div className="mb-3">
                <div className="grid grid-cols-4 gap-2 mb-3">
                    <div className=" h-[74px] border border-[ #D1D5DB] rounded-md">
                        <div className="upload-btn-img">
                            {firstImage ? (
                                firstImage.originalName &&
                                firstImage.originalName.indexOf(".mp4") > -1 ? (
                                    <video
                                        src={
                                            firstImage
                                                ? getImage(firstImage)
                                                : storeImg
                                        }
                                        alt=""
                                        className="w-full h-full object-cover object-center rounded-md"
                                    />
                                ) : (
                                    <img
                                        src={
                                            firstImage
                                                ? getImage(firstImage)
                                                : storeImg
                                        }
                                        alt=""
                                        className="w-full h-full object-cover object-center rounded-md"
                                    />
                                )
                            ) : (
                                <img
                                    src={storeImg}
                                    alt=""
                                    className="w-full h-full object-cover object-center rounded-md"
                                />
                            )}
                            <input
                                type="file"
                                disabled={showEdit}
                                accept="image/*, video/*"
                                name="banner_image"
                                onChange={(e) => changeBanner(e, 1)}
                            />
                        </div>
                    </div>
                    <div className=" h-[74px] border border-[ #D1D5DB] rounded-md">
                        <div className="upload-btn-img">
                            {secondImage ? (
                                secondImage.originalName &&
                                secondImage.originalName.indexOf(".mp4") >
                                    -1 ? (
                                    <video
                                        src={
                                            secondImage
                                                ? getImage(secondImage)
                                                : storeImg
                                        }
                                        alt=""
                                        className="w-full h-full object-cover object-center rounded-md"
                                    />
                                ) : (
                                    <img
                                        src={
                                            secondImage
                                                ? getImage(secondImage)
                                                : storeImg
                                        }
                                        alt=""
                                        className="w-full h-full object-cover object-center rounded-md"
                                    />
                                )
                            ) : (
                                <img
                                    src={storeImg}
                                    alt=""
                                    className="w-full h-full object-cover object-center rounded-md"
                                />
                            )}
                            <input
                                type="file"
                                disabled={showEdit}
                                accept="image/*, video/*"
                                name="banner_image"
                                onChange={(e) => changeBanner(e, 2)}
                            />
                        </div>
                    </div>
                    <div className=" h-[74px] border border-[ #D1D5DB] rounded-md">
                        <div className="upload-btn-img">
                            {thirdImage ? (
                                thirdImage.originalName &&
                                thirdImage.originalName.indexOf(".mp4") > -1 ? (
                                    <video
                                        src={
                                            thirdImage
                                                ? getImage(thirdImage)
                                                : storeImg
                                        }
                                        alt=""
                                        className="w-full h-full object-cover object-center rounded-md"
                                    />
                                ) : (
                                    <img
                                        src={
                                            thirdImage
                                                ? getImage(thirdImage)
                                                : storeImg
                                        }
                                        alt=""
                                        className="w-full h-full object-cover object-center rounded-md"
                                    />
                                )
                            ) : (
                                <img
                                    src={storeImg}
                                    alt=""
                                    className="w-full h-full object-cover object-center rounded-md"
                                />
                            )}
                            <input
                                type="file"
                                disabled={showEdit}
                                accept="image/*, video/*"
                                name="banner_image"
                                onChange={(e) => changeBanner(e, 3)}
                            />
                        </div>
                    </div>
                    <div className=" h-[74px] border border-[ #D1D5DB] rounded-md">
                        <div className="upload-btn-img">
                            {fourthImage ? (
                                fourthImage.originalName &&
                                fourthImage.originalName.indexOf(".mp4") >
                                    -1 ? (
                                    <video
                                        src={
                                            fourthImage
                                                ? getImage(fourthImage)
                                                : storeImg
                                        }
                                        alt=""
                                        className="w-full h-full object-cover object-center rounded-md"
                                    />
                                ) : (
                                    <img
                                        src={
                                            fourthImage
                                                ? getImage(fourthImage)
                                                : storeImg
                                        }
                                        alt=""
                                        className="w-full h-full object-cover object-center rounded-md"
                                    />
                                )
                            ) : (
                                <img
                                    src={storeImg}
                                    alt=""
                                    className="w-full h-full object-cover object-center rounded-md"
                                />
                            )}
                            <input
                                type="file"
                                disabled={showEdit}
                                accept="image/*, video/*"
                                name="banner_image"
                                onChange={(e) => changeBanner(e, 4)}
                            />
                        </div>
                    </div>
                </div>
                <p className="text-extraSmall text-black-50">
                    You can select upto 4 media files- images, videos
                </p>
            </div>
            <div className="space-y-3">
                <div
                    className={`flex flex-col py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm ${
                        IsNullOrEmpty(itemName) && isValidated
                            ? "border-red-500"
                            : ""
                    } `}
                    style={{ background: showEdit ? "#F3F5F6" : "#FFFFFF" }}
                >
                    <label
                        htmlFor="Item-name"
                        className="text-black-50 capitalize mb-px"
                    >
                        Item name
                    </label>
                    <input
                        type="text"
                        disabled={showEdit}
                        className="text-black-60 outline-none "
                        id="Item-name"
                        value={itemName}
                        onChange={(e) => setitemName(e.target.value)}
                    />
                </div>
                {IsNullOrEmpty(itemName) && isValidated && (
                    <span className="flex items-center font-medium tracking-wide text-red-500 text-sm mt-1 ml-1">
                        Product name should be valid
                    </span>
                )}

                <div className="grid grid-cols-2 gap-y-3 gap-x-2">
                    <div
                        style={{ background: showEdit ? "#F3F5F6" : "#FFFFFF" }}
                        className="flex flex-col py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm"
                    >
                        <label
                            htmlFor="Item-Price"
                            className="text-black-50 capitalize mb-px"
                        >
                            Item Price
                        </label>
                        <input
                            type="text"
                            disabled={showEdit}
                            className="text-black-60 outline-none"
                            id="Item-Price"
                            value={itemPrice}
                            onChange={(e) => setitemPrice(e.target.value)}
                        />
                    </div>
                    {IsNullOrEmpty(itemPrice) && isValidated && (
                        <span className="flex items-center font-medium tracking-wide text-red-500 text-sm mt-1 ml-1">
                            Product price should be valid
                        </span>
                    )}
                    <div
                        style={{ background: showEdit ? "#F3F5F6" : "#FFFFFF" }}
                        className="flex flex-col py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm"
                    >
                        <label
                            htmlFor="Stock"
                            className="text-black-50 capitalize mb-px"
                        >
                            Stock
                        </label>
                        <input
                            type="text"
                            className="text-black-60 outline-none"
                            id="Stock"
                            disabled={showEdit}
                            value={stockQuantity}
                            onChange={(e) => setstockQuantity(e.target.value)}
                        />
                    </div>
                    {IsNullOrEmpty(stockQuantity) && isValidated && (
                        <span className="flex items-center font-medium tracking-wide text-red-500 text-sm mt-1 ml-1">
                            Stock Quantity should be valid
                        </span>
                    )}
                </div>
                <div
                    style={{ background: showEdit ? "#F3F5F6" : "#FFFFFF" }}
                    className="flex flex-col py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm"
                >
                    <label
                        htmlFor="Item-Discription"
                        className="text-black-50 capitalize mb-px"
                    >
                        Item Description
                    </label>
                    <input
                        type="text"
                        disabled={showEdit}
                        className="text-black-60 outline-none"
                        id="Item-Discription"
                        value={itemDescription}
                        onChange={(e) => setitemDescription(e.target.value)}
                    />
                </div>
                {IsNullOrEmpty(itemDescription) && isValidated && (
                    <span className="flex items-center font-medium tracking-wide text-red-500 text-sm mt-1 ml-1">
                        Product description should be valid
                    </span>
                )}
                <div
                    style={{ background: showEdit ? "#F3F5F6" : "#FFFFFF" }}
                    className="border border-[#D1D5DB] rounded-md py-[9px] px-[13px] "
                >
                    <div
                        style={{ background: showEdit ? "#F3F5F6" : "#FFFFFF" }}
                        onClick={() => setDiscount(!discount)}
                        className="flex flex-col bg-white w-full text-sm cursor-pointer"
                    >
                        <label
                            htmlFor="Courier"
                            className="text-black-50 capitalize mb-px"
                        >
                            Discount
                        </label>

                        <div className="flex items-start justify-between">
                            <span className="text-black-30">
                                {showEdit ? discountPer + "%" : "Set Discount"}
                            </span>
                            <span className={discount && "rotate-180"}>
                                <svg
                                    width="10"
                                    height="6"
                                    viewBox="0 0 10 6"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M9.08366 0.75L5.00033 4.83333L0.916992 0.75"
                                        stroke="black"
                                        strokeOpacity="0.5"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div
                        className={`${!discount && "hidden"} bg-white mt-2`}
                        style={{ background: showEdit ? "#F3F5F6" : "#FFFFFF" }}
                    >
                        <div className={`space-y-1.5`}>
                            <div className="flex items-center justify-between">
                                <label
                                    htmlFor=""
                                    className="text-sm text-black-80"
                                >
                                    Discount percentage%
                                </label>
                                <input
                                    type="text"
                                    disabled={showEdit}
                                    className="w-24 py-[7px] rounded-md border border-[#D1D5DB] text-center outline-none  text-black-50"
                                    value={discountPer}
                                    onChange={(e) =>
                                        setDiscountPer(e.target.value)
                                    }
                                />
                            </div>
                            <div className="flex items-center justify-between">
                                <label
                                    htmlFor=""
                                    className="text-sm text-black-80"
                                >
                                    Price after discount
                                </label>
                                <input
                                    value={finalDiscount}
                                    disabled={showEdit}
                                    type="text"
                                    className="w-24 py-[7px] rounded-md border border-[#D1D5DB] text-center outline-none  text-black-50"
                                />
                            </div>
                            <div className="flex items-center justify-between">
                                <div className="flex flex-col">
                                    <label
                                        htmlFor=""
                                        className="text-sm text-black-80"
                                    >
                                        Discount code
                                    </label>
                                    <span className="text-extraSmall text-orange-color">
                                        *Set 6 digits code
                                        <button
                                            disabled={showEdit}
                                            className="mx-3 p-[2px] rounded-lg text-sm text-white border border-orange-color bg-orange-color capitalize"
                                            onClick={() =>
                                                setDiscountCode(makeId(6))
                                            }
                                        >
                                            Generate
                                        </button>
                                    </span>
                                </div>
                                <input
                                    value={discountCode}
                                    disabled
                                    minLength={6}
                                    maxLength={6}
                                    onChange={(e) =>
                                        setDiscountCode(e.target.value)
                                    }
                                    type="text"
                                    className="w-24 py-[7px] rounded-md border border-[#D1D5DB] text-center outline-none text-black-50"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-4 gap-y-3 gap-x-2">
                    <div
                        style={{ background: showEdit ? "#F3F5F6" : "#FFFFFF" }}
                        className="flex flex-col py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm relative"
                    >
                        <label
                            htmlFor="Item-Price"
                            className="text-black-50 capitalize mb-px"
                        >
                            Height
                        </label>
                        <input
                            type="text"
                            disabled={showEdit}
                            className="text-black-60 outline-none"
                            id="Item-Price"
                            value={height}
                            onChange={(e) => setHeight(e.target.value)}
                        />
                        <span className="text-black-60  pointer-events-none absolute right-[4px] bottom-[9px]">
                            cm
                        </span>
                    </div>
                    <div
                        style={{ background: showEdit ? "#F3F5F6" : "#FFFFFF" }}
                        className="flex flex-col py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm relative"
                    >
                        <label
                            htmlFor="Item-Price"
                            className="text-black-50 capitalize mb-px"
                        >
                            Width
                        </label>
                        <input
                            type="text"
                            disabled={showEdit}
                            className="text-black-60 outline-none"
                            id="Item-Price"
                            value={width}
                            onChange={(e) => setWidth(e.target.value)}
                        />
                        <span className="text-black-60  pointer-events-none absolute right-[4px] bottom-[9px]">
                            cm
                        </span>
                    </div>
                    <div
                        style={{ background: showEdit ? "#F3F5F6" : "#FFFFFF" }}
                        className="flex flex-col py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm relative"
                    >
                        <label
                            htmlFor="Item-Price"
                            className="text-black-50 capitalize mb-px"
                        >
                            Length
                        </label>
                        <input
                            type="text"
                            disabled={showEdit}
                            className="text-black-60 outline-none"
                            id="Item-Price"
                            value={length}
                            onChange={(e) => setLength(e.target.value)}
                        />
                        <span className="text-black-60  pointer-events-none absolute right-[4px] bottom-[9px]">
                            cm
                        </span>
                    </div>
                    <div
                        style={{ background: showEdit ? "#F3F5F6" : "#FFFFFF" }}
                        className="flex flex-col py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm relative"
                    >
                        <label
                            htmlFor="Item-Price"
                            className="text-black-50 capitalize mb-px"
                        >
                            Weight
                        </label>
                        <input
                            type="text"
                            disabled={showEdit}
                            className="text-black-60 outline-none"
                            id="Item-Price"
                            value={weight}
                            onChange={(e) => setWeight(e.target.value)}
                        />
                        <span className="text-black-60  pointer-events-none absolute right-[4px] bottom-[9px]">
                            kg
                        </span>
                    </div>
                </div>
                {
                    <span className="text-extraSmall text-orange-color">
                        All dimensions should be in cm, kg
                    </span>
                }
                {(IsNullOrEmpty(height) ||
                    IsNullOrEmpty(length) ||
                    IsNullOrEmpty(width) ||
                    IsNullOrEmpty(weight)) &&
                    isValidated && (
                        <span className="flex items-center font-medium tracking-wide text-red-500 text-sm mt-1 ml-1">
                            Product dimensions should be valid
                        </span>
                    )}
            </div>
            <div className="flex items-center gap-3 mt-3">
                {isAdd ? (
                    <>
                        <button
                            onClick={() => props.onClose()}
                            className="flex justify-center items-center py-[9px] px-[30px] w-full rounded-lg bg-gray-300 text-gray-600 font-bold text-sm capitalize border border-transparent"
                        >
                            <span>Cancel</span>
                        </button>
                        <button
                            onClick={() => handleAdd()}
                            className="flex justify-center items-center py-[9px] px-[30px] w-full rounded-lg bg-orange-color text-white font-bold text-sm capitalize border border-transparent"
                        >
                            <span>Add Product</span>
                        </button>
                    </>
                ) : (
                    <>
                        {showEdit ? (
                            <button
                                onClick={() => setEdit(false)}
                                className="flex justify-center items-center py-[9px] px-[30px] w-full rounded-lg bg-orange-color text-white font-bold text-sm capitalize border border-transparent"
                            >
                                <span className="inline-block mr-2 ">
                                    <svg
                                        width="15"
                                        height="15"
                                        viewBox="0 0 15 15"
                                        className="stroke-current"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M6.75 2.75H3C2.17157 2.75 1.5 3.42158 1.5 4.25V12.5C1.5 13.3284 2.17157 14 3 14H11.25C12.0784 14 12.75 13.3284 12.75 12.5V8.75M11.6893 1.68934C12.2751 1.10355 13.2249 1.10355 13.8107 1.68934C14.3964 2.27513 14.3964 3.22487 13.8107 3.81066L7.37132 10.25H5.25L5.25 8.12868L11.6893 1.68934Z"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                                <span>Edit</span>
                            </button>
                        ) : (
                            <button
                                onClick={() => handleUpdate()}
                                className="flex justify-center items-center py-[9px] px-[30px] w-full rounded-lg bg-orange-color text-white font-bold text-sm capitalize border border-transparent"
                            >
                                <span className="inline-block mr-2 ">
                                    <svg
                                        width="15"
                                        height="15"
                                        viewBox="0 0 15 15"
                                        className="stroke-current"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M6.75 2.75H3C2.17157 2.75 1.5 3.42158 1.5 4.25V12.5C1.5 13.3284 2.17157 14 3 14H11.25C12.0784 14 12.75 13.3284 12.75 12.5V8.75M11.6893 1.68934C12.2751 1.10355 13.2249 1.10355 13.8107 1.68934C14.3964 2.27513 14.3964 3.22487 13.8107 3.81066L7.37132 10.25H5.25L5.25 8.12868L11.6893 1.68934Z"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                                <span>Update</span>
                            </button>
                        )}
                        {!showEdit && (
                            <button
                                onClick={() => handleDelete()}
                                className="flex justify-center items-center py-[9px] px-[30px] w-full rounded-lg bg-white text-black-50 font-medium text-sm capitalize border border-black-10"
                            >
                                <span className="inline-block mr-2 ">
                                    <svg
                                        width="15"
                                        height="16"
                                        className="stroke-current"
                                        viewBox="0 0 15 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M12.75 4.25L12.0995 13.3569C12.0434 14.1418 11.3903 14.75 10.6033 14.75H4.39668C3.60972 14.75 2.95656 14.1418 2.90049 13.3569L2.25 4.25M6 7.25V11.75M9 7.25V11.75M9.75 4.25V2C9.75 1.58579 9.41421 1.25 9 1.25H6C5.58579 1.25 5.25 1.58579 5.25 2V4.25M1.5 4.25H13.5"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                                <span>Delete</span>
                            </button>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
